export default "__VITE_ASSET__bHi7G65B__"